import { motion } from "framer-motion";
import { useRef } from "react";

export function BlurText({
    text = "",
    delay = 100,
    className = "",
    tag: Tag = "h1",
}) {
    const words = text.split(" ");
    
    const container = {
        hidden: { opacity: 0 },
        visible: (i = 1) => ({
            opacity: 1,
            transition: { staggerChildren: 0.12, delayChildren: delay / 1000 },
        }),
    };

    const child = {
        visible: {
            opacity: 1,
            filter: "blur(0px)",
            y: 0,
            transition: {
                type: "spring",
                damping: 12,
                stiffness: 100,
            },
        },
        hidden: {
            opacity: 0,
            filter: "blur(10px)",
            y: 20,
            transition: {
                type: "spring",
                damping: 12,
                stiffness: 100,
            },
        },
    };

    return (
        <Tag className={className}>
            <motion.div
                variants={container}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-50px" }}
                className="flex flex-wrap"
            >
                {words.map((word, index) => (
                    <motion.span
                        variants={child}
                        key={index}
                        className="mr-[0.25em]"
                    >
                        {word}
                    </motion.span>
                ))}
            </motion.div>
        </Tag>
    );
}

